import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import posthog from "posthog-js";
import * as hubActions from "./hubActions";
import { emitTimesheetRealtimeFromHub } from "../domain/timesheets/timesheetRealtimeBus";
import { handleAttendanceRealtimeEvent } from "../domain/attendance/attendanceActions";

class RealTimeUpdates extends React.Component {
    //This is to make sure to avoid aditions of multiple listers for same method.
    bindHubMethod = (methodName, callback) => {
        const { hubConnection, isLoggedIn } = this.props;
        if (hubConnection && isLoggedIn) {
            // Check if we already have this method bound to avoid duplicates
            if (!this.boundMethods) {
                this.boundMethods = new Set();
            }

            if (!this.boundMethods.has(methodName.toLowerCase())) {
                hubConnection.on(methodName, callback);
                this.boundMethods.add(methodName.toLowerCase());
                console.log(`Bound hub method: ${methodName}`);
            }
        }
    };
    componentDidMount() {
        this.setupHubConnection();
    }

    componentDidUpdate(prevProps) {
        const { isLoggedIn, hubConnection } = this.props;
        const { isLoggedIn: prevIsLoggedIn, hubConnection: prevHubConnection } = prevProps;

        console.log('componentDidUpdate - isLoggedIn:', isLoggedIn, 'prevIsLoggedIn:', prevIsLoggedIn);
        console.log('componentDidUpdate - hubConnection:', hubConnection, 'prevHubConnection:', prevHubConnection);

        // If user just logged in and we have a hub connection, set it up
        if (isLoggedIn && !prevIsLoggedIn && hubConnection) {
            console.log("User logged in, setting up hub connection");
            this.setupHubConnection();
        }

        // If hub connection changed and user is logged in, set it up
        if (isLoggedIn && hubConnection && hubConnection !== prevHubConnection) {
            console.log("Hub connection updated, setting up connection");
            this.boundMethods = new Set();
            this.isHubSetup = false;
            this.closeHandlerAdded = false;
            this.setupHubConnection();
        }
    }

    setupHubConnection = () => {
        const { hubConnection, hubActions, history, isLoggedIn } = this.props;
        console.log('setupHubConnection called with:', { isLoggedIn, hubConnection, hubActions });

        const {
            onHubUserLogin,
            onHubNotificationUpdate,
            onHubGeneralNotification,
        } = hubActions;

        if (!isLoggedIn || !hubConnection) {
            console.log("User not logged in or hub connection not available", { isLoggedIn, hubConnection });
            return;
        }

        // this.bindHubMethod("userLogin", userId => onHubUserLogin({ userId }));

        this.bindHubMethod("NotificationUpdate", (id, message) =>
            onHubNotificationUpdate({ id, message, history })
        );

        this.bindHubMethod("TimesheetRealtimeEvent", (jsonPayload) => {
            try {
                const data =
                    typeof jsonPayload === "string" ? JSON.parse(jsonPayload) : jsonPayload;
                emitTimesheetRealtimeFromHub(data);
            } catch {
                console.warn("TimesheetRealtimeEvent: invalid JSON");
            }
        });

        this.bindHubMethod("AttendanceRealtimeEvent", (jsonPayload) => {
            try {
                const data =
                    typeof jsonPayload === "string" ? JSON.parse(jsonPayload) : jsonPayload;
                this.props.dispatchAttendanceRealtime(data);
            } catch {
                console.warn("AttendanceRealtimeEvent: invalid JSON");
            }
        });

        // this.bindHubMethod("GeneralNotification", (notification) =>
        //     onHubGeneralNotification({ notification, history })
        // );

        // Check if already set up to prevent duplicate starts
        if (this.isHubSetup) {
            console.log('Hub connection already set up, skipping start...');
            return;
        }
        console.log('Hub connection state:', hubConnection.state);
        if (hubConnection.state === "Disconnected") {
            console.log('Starting hub connection...');
            hubConnection
                .start()
                .then(() => {
                    console.log("Realtime connection established successfully");
                    this.isHubSetup = true;
                })
                .catch(err => {
                    if (typeof posthog !== "undefined" && posthog.capture) {
                        posthog.capture("hubRealtimeConnection", {
                            type: "exception",
                            success: false,
                            reason: err?.message ?? "Error while establishing realtime connection",
                        });
                    }
                });
        } else {
            console.log('Hub connection already in state:', hubConnection.state);
            this.isHubSetup = true;
        }

        // Handle connection close - only add once
        if (!this.closeHandlerAdded) {
            this.reconnectTimeout = null;
            hubConnection.onclose((error) => {
                if (error) {
                    if (typeof posthog !== "undefined" && posthog.capture) {
                        posthog.capture("hubRealtimeConnection", {
                            type: "exception",
                            success: false,
                            reason: error?.message ?? "Connection closed due to error",
                        });
                    }
                } else {
                    console.log("Connection closed gracefully");
                }

                // Reset setup flag when connection closes
                this.isHubSetup = false;

                // Attempt to restart connection after 5 seconds
                this.reconnectTimeout = setTimeout(() => {
                    if (hubConnection.state === "Disconnected") {
                        hubConnection.start()
                            .then(() => {
                                console.log("Realtime connection re-established");
                                this.isHubSetup = true;
                            })
                            .catch(err => {
                                if (typeof posthog !== "undefined" && posthog.capture) {
                                    posthog.capture("hubRealtimeConnection", {
                                        type: "exception",
                                        success: false,
                                        reason: err?.message ?? "Failed to re-establish connection",
                                    });
                                }
                            });
                    }
                }, 5000);
            });
            this.closeHandlerAdded = true;
        }
    }

    componentWillUnmount() {
        // Clear any pending reconnection attempts
        if (this.reconnectTimeout) {
            clearTimeout(this.reconnectTimeout);
        }
    }

    render() {
        return null;
    }
}
const mapStateToProps = ({ accountReducer }) => {
    const { isLoggedIn, hubConnection } = accountReducer;
    return {
        isLoggedIn,
        hubConnection
    };
};
const mapDispatchToProps = dispatch => {
    return {
        hubActions: bindActionCreators(hubActions, dispatch),
        dispatchAttendanceRealtime: (payload) => dispatch(handleAttendanceRealtimeEvent(payload)),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RealTimeUpdates));